import {
  SupportedLocale,
  localizedValue,
} from '../../../helpers/LocaleHelpers';

export const PORTER_RATING =
  'https://dom-content-vault-prod-cdn-assets.porter.in/download_app_icon_v2_75a896e37e/download_app_icon_v2_75a896e37e.svg';
export const PORTER_RATING_ALT = 'Porter App Icon';

export const COPYRIGHT_INFO = `© ${new Date().getFullYear()} SmartShift Logistics Solutions Pvt. Ltd.`;

// Fallback download-CTA assets used when CMS data is unavailable.
export const DEFAULT_QR_IMAGE = '/assets/download-qr-code.png';
export const DEFAULT_PLAY_STORE_IMAGE = '/assets/googleplay.png';
export const DEFAULT_APP_STORE_IMAGE = '/assets/appstore.png';

export interface FooterText {
  followUs: string;
  downloadApp: string;
  scanQr: string;
}

type FooterLang = 'en' | 'bn' | 'tr';

const LOCALE_LANG: Record<SupportedLocale, FooterLang> = {
  'en': 'en',
  'en-AE': 'en',
  'en-TR': 'en',
  'en-TK': 'en',
  'en-IN': 'en',
  'en-MY': 'en',
  'bn-BD': 'bn',
  'tr-TR': 'tr',
};

const FOOTER_TEXT: Record<FooterLang, FooterText> = {
  en: {
    followUs: 'Follow us on',
    downloadApp: 'Download our app now!',
    scanQr: 'Scan the QR Code to download',
  },
  bn: {
    followUs: 'আমাদের অনুসরণ করুন:',
    downloadApp: 'এখনই আমাদের অ্যাপটি ডাউনলোড করুন!',
    scanQr: 'ডাউনলোড করতে কিউআর কোড স্ক্যান করুন',
  },
  tr: {
    followUs: 'Bizi takip edin:',
    downloadApp: 'Uygulamamızı hemen indirin!',
    scanQr: 'İndirmek için QR Kodunu tarayın',
  },
};

export function getFooterText(locale: string | undefined): FooterText {
  return FOOTER_TEXT[localizedValue(locale, LOCALE_LANG, 'en')];
}
